// src/helpers/rutaComandas.js
import axios from "axios";

const BASE_URL = "https://backsanpancracio.us-3.evennode.com"; // fallback
const API_BASE = process.env.REACT_APP_API || BASE_URL;

// Log sólo en desarrollo para verificar a qué back apunta
if (process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line no-console
  console.log("[API_BASE]", API_BASE);
}

// Axios instance
const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// No-cache por defecto en GET (evita respuestas stale de proxies/CDN/navegador)
api.defaults.headers.get = {
  ...(api.defaults.headers.get || {}),
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
  Expires: "0",
};

// Inyecta token automáticamente (tu backend usa header 'token')
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || "";
  if (token) config.headers.token = token;
  return config;
});

// Normaliza el error (contempla .msg y .err)
const parseError = (error) =>
  error?.response?.data?.msg ||
  error?.response?.data?.err ||
  error?.response?.data ||
  error?.message ||
  "Error desconocido";

// Helper para agregar timestamp anti-cache a params GET
const withNoCache = (params) => ({ ...(params || {}), _ts: Date.now() });

/* ──────────────────────────────────────────────────────────
   PENDIENTES POR CLIENTE  ✅
────────────────────────────────────────────────────────── */
export async function getComandasPendientesByCliente(clienteId) {
  try {
    const { data } = await api.get("/comandas/pendientes", {
      params: withNoCache({ cliente: clienteId }),
    });
    return data?.pendientes || [];
  } catch (e) {
    console.error("pendientes error:", e);
    return [];
  }
}

// ✅ GET: Traer todas las comandas
export const getComandas = async () => {
  try {
    const { data } = await api.get("/comandas", {
      params: withNoCache(),
    });
    return data; // { ok, comandas, cantidad }
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

// ✅ GET: Traer una comanda por ID
export const getComandaById = async (id) => {
  try {
    const { data } = await api.get(`/comandas/${id}`, {
      params: withNoCache(),
    });
    return data; // { ok, comanda }
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

// ✅ POST: Crear nueva comanda
export const postComanda = async (comandaData) => {
  try {
    const { data } = await api.post("/comandas", comandaData, {
      headers: { "Content-Type": "application/json" },
    });
    return data;
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

// ✅ PUT: Actualizar comanda
export const putComanda = async (id, comandaData) => {
  try {
    const { data } = await api.put(`/comandas/${id}`, comandaData, {
      headers: { "Content-Type": "application/json" },
    });
    return data;
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

// ✅ DELETE: Desactivar comanda
export const deleteComanda = async (id) => {
  try {
    const { data } = await api.delete(`/comandas/${id}`, {
      params: withNoCache(),
    });
    return data;
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

/* ───────── PAGOS embebidos ───────── */

// ➕ Agregar pago a una comanda
export const postPagoComanda = async (idComanda, pago) => {
  try {
    const { data } = await api.post(`/comandas/${idComanda}/pagos`, pago, {
      headers: { "Content-Type": "application/json" },
    });
    return data; // { ok, comanda, pagoId? }
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

// ✏️ Editar un pago puntual
export const putPagoComanda = async (idComanda, idPago, pago) => {
  try {
    const { data } = await api.put(`/comandas/${idComanda}/pagos/${idPago}`, pago, {
      headers: { "Content-Type": "application/json" },
    });
    return data; // { ok, comanda }
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

// 🗑️ Eliminar un pago
export const deletePagoComanda = async (idComanda, idPago) => {
  try {
    const { data } = await api.delete(`/comandas/${idComanda}/pagos/${idPago}`, {
      params: withNoCache(),
    });
    return data; // { ok, comanda }
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

/**
 * Pendientes por TERCERO (y opcional CLIENTE):
 * GET /comandas/pendientes-tercero?tercero=&cliente=
 * Devuelve [{ _id, codcom, nroviaje, fecha, factura, pactado, pagado, saldo, cliente }]
 */
export const getComandasPendientesTercero = async (terceroId, clienteId) => {
  if (!terceroId) return [];
  try {
    const params = withNoCache({ tercero: terceroId, ...(clienteId ? { cliente: clienteId } : {}) });
    const { data } = await api.get("/comandas/pendientes-tercero", { params });
    return data?.pendientes || [];
  } catch (e) {
    console.error("pendientes-tercero error:", e);
    return [];
  }
};
